import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isAlreadyUnderMinutes, openFinalGame } from "../../../utils/utils";
import { fetchFinalStatus } from "../../../store/contest/contest-actions";
import { openGamePlethora } from "../../../utils/providerOpenHandlers";
import StudentInfo from "../../../components/sections/CompetitionStatus/shared/StudentInfo/StudentInfo";
import ItemBlock from "../../../components/sections/ContestInfo/itemBlock/ItemBlock";
import FinalDateCountdown from "./FinalDateCountdown/FinalDateCountdown";
import FinalLaunchPopup from "./FinalLaunchPopup/FinalLaunchPopup";
import FinalEndPopup from "../FinalPopup/FinalEnd/FinalEndPopup";
import WarningBar from "./WarningBar/WarningBar";
import classes from "./WaitingForFinalOpenMode.module.css";

const WaitingForFinalOpenMode = ({ targetDate ,setFinalPageMode}) => {

  const dispatch = useDispatch();
  const { texts, lang } = useSelector((state) => state.translate);
  const { school } = useSelector((state) => state.auth);
  const [showLaunchPopup, setShowLaunchPopup] = useState(false);
  const [showFinalEndPopup, setShowFinalEndPopup] = useState(false);
  const [isUnder10Minutes, setIsUnder10Minutes] = useState(() => isAlreadyUnderMinutes(targetDate, 10));
  const [lockBtnWhenChackIsAllowed, setLockBtnWhenChackIsAllowed] = useState(false);
  const [{ showWarning, textWarning }, setShowWarning] = useState({ showWarning: false, textWarning: '' });

  const onConfirmEnterFinal = async () => {
    if (!school?.id)
      return;
    setLockBtnWhenChackIsAllowed(true);
    const result = await dispatch(fetchFinalStatus(school?.id));
    setLockBtnWhenChackIsAllowed(false);
    debugger
    if (!result?.ok) {
      setShowWarning({ showWarning: true, textWarning: texts?.tryAgainMessage });
      setShowLaunchPopup(false);
      return;
    }
    const { isFinalEnd, isFinalOpen, isTeamMember,finalGameUrl } = result.finalStatus ?? {};
    if (isFinalEnd) {
      setShowFinalEndPopup(true);
      setShowLaunchPopup(false);
      return;
    }
    if (!isTeamMember) {
      setShowWarning({ showWarning: true, textWarning: texts?.warningNotInTeam });
      setShowLaunchPopup(false);
      return;
    }
    if (!isFinalOpen) {
      setShowWarning({ showWarning: true, textWarning: texts?.warningNoLaunchYet });
      setShowLaunchPopup(false);
      return;
    } 
    if (isFinalOpen && isTeamMember) {
      setShowLaunchPopup(false);
      setFinalPageMode({ mainMode: true, waitingMode: false });
      openGamePlethora(finalGameUrl, lang)
      return;
    }
  };

  return (
    <ItemBlock className={classes.wrapper} icon={<StudentInfo />}>
      <div className={classes.Container}>
        {!isUnder10Minutes ?
          <FinalDateCountdown targetDate={targetDate} timeReached={10} onTimeReached={() => setIsUnder10Minutes(true)} />
          :
          <div className={classes.FinalDayButtonWrapper}>
            <p className={classes.boldText}>{texts?.imedetliWaitingForFinal}</p>
            <p className={classes.texts}>{texts?.waitingForFinalOpenLink}</p>
            <button className={classes.finalDayButton} onClick={() => setShowLaunchPopup(true)} >
              <p className={classes.finalDayButtonText}>{texts?.enterToFinal}</p>
            </button>
            <p className={classes.underButtonText}>{texts?.clickOnlyAfterFinalOpen}</p>
          </div>
        }
        {showLaunchPopup && <FinalLaunchPopup onClose={() => setShowLaunchPopup(false)} onConfirm={onConfirmEnterFinal} lockBtnWhenChackIsAllowed={lockBtnWhenChackIsAllowed} />}
        {showWarning && <WarningBar text={textWarning} color="#F03C3C" durationMs={10000} onDismiss={() => setShowWarning({ showWarning: false, textWarning: '' })} />}
        {showFinalEndPopup && <FinalEndPopup onClose={() => setShowFinalEndPopup(false)} />}
      </div>
    </ItemBlock>
  );
};

export default WaitingForFinalOpenMode;
